import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import "bootstrap/dist/css/bootstrap.min.css";
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';
import UserInfoProvider from "./PageDesign/Components/Context/UserInfoContext";
import PacksProvider from "./PageDesign/Components/Context/PacksContext";
import MedicalContextProvider from "./PageDesign/Components/Context/MedicalContext";
import SignInRoute from './PageDesign/SignInRoute';
import VerifyEmailRoute from "./PageDesign/VerifyEmailRoute";
import InterventionPlanRoute from "./PageDesign/InterventionPlanRoute";
//import UserWelcomeRoute from "./PageDesign/UserWelcomeRoute";
//import UserWelcomeSurveyResultsRoute from "./PageDesign/UserWelcomeSurveyResultsRoute"
//import UserWelcomeIntroRoute from "./PageDesign/UserWelcomeIntroRoute";
import UserProfileHealthReportRoute from "./PageDesign/UserProfileHealthReportRoute";
import UserProfileMedicalDataRoute from "./PageDesign/UserProfileMedicalDataRoute";
import UserProfileRoute from "./PageDesign/UserProfileRoute";
import UserProfileCalculatorHomeRoute from "./PageDesign/UserProfileCalculatorHomeRoute";
import CalculatorHeartAgeRoute from "./PageDesign/CalculatorHeartAgeRoute";
import CalculatorHabitsRoute from "./PageDesign/CalculatorHabitsRoute";
import CalculatorDiabetesRoute from "./PageDesign/CalculatorDiabetesRoute";
import CalculatorSleepRoute from "./PageDesign/CalculatorSleepRoute";
import CalculatorMetabolicRoute from "./PageDesign/CalculatorMetabolicRoute";
import PacksSelectionRoute from "./PageDesign/PacksSelectionRoute";
import PackDetailsRoute from "./PageDesign/PackDetailsRoute";
import RecommenderRoute from "./PageDesign/RecommenderRoute";
import RecommendedExamsRoute from "./PageDesign/RecommendedExamsRoute";
import OrderCheckoutRoute from "./PageDesign/OrderCheckoutRoute";
import OrderDownloadRoute from "./PageDesign/OrderDownloadRoute";
import OrderRecoveryRoute from "./PageDesign/OrderRecoveryRoute";
import OrderPendingRoute from "./PageDesign/OrderPendingRoute";
import CompanyCampaigns from "./PageDesign/CampaignsRoute";
import CheckoutCoupons from "./PageDesign/CouponsRoute";
import Error404 from "./PageDesign/Error404Route";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

const Router = createBrowserRouter([
  {
    path: "/",
    element: (
      <>
      <title>Yo Me Controlo</title>
      <MedicalContextProvider>
      <PacksProvider>
      <UserInfoProvider>
      <SignInRoute />
      </UserInfoProvider>
      </PacksProvider>
      </MedicalContextProvider>
      </>
    ),
    errorElement: <Error404/>,
  },
  {
    path: "/verificar-correo",
    element: (
      <>
      <title>YMC | Verificar Correo</title>
      <MedicalContextProvider>
      <PacksProvider>
        <VerifyEmailRoute />
      </PacksProvider>
      </MedicalContextProvider>
      </>
    ),
  },
  {
    path: "/perfil-de-usuario",
    element: (
      <>
      <title>YMC | Perfil de Usuario</title>
      <MedicalContextProvider>
      <PacksProvider>
        <UserProfileRoute />
      </PacksProvider>
      </MedicalContextProvider>
      </>
    ),
  },
  {
    path: "/plan-de-intervencion",
    element: (
      <>
      <title>YMC | Plan de Intervención</title>
      <MedicalContextProvider>
      <PacksProvider>
        <InterventionPlanRoute />
      </PacksProvider>
      </MedicalContextProvider>
      </>
    ),
  },
  {
    path: "/perfil-de-usuario/informe-de-salud",
    element: (
      <>
      <title>YMC | Informe de Salud</title>
      <MedicalContextProvider>
      <PacksProvider>
        <UserProfileHealthReportRoute />
      </PacksProvider>
      </MedicalContextProvider>
      </>
    ),
  },
  {
    path: "/perfil-de-usuario/antecedentes-medicos",
    element: (
      <>
      <title>YMC | Antecedentes Médicos</title>
      <MedicalContextProvider>
      <PacksProvider>
        <UserProfileMedicalDataRoute />
      </PacksProvider>
      </MedicalContextProvider>
      </>
    ),
  },
  {
    path: "/perfil-de-usuario/calculadora-de-salud",
    element: (
      <>
      <title>YMC | Calculadora de Riesgos</title>
      <MedicalContextProvider>
      <PacksProvider>
        <UserProfileCalculatorHomeRoute />
      </PacksProvider>
      </MedicalContextProvider>
      </>
    ),
  },
  {
    path: "/perfil-de-usuario/edad-del-corazon",
    element: (
      <>
      <title>YMC | Edad del Corazón</title>
      <MedicalContextProvider>
      <PacksProvider>
        <CalculatorHeartAgeRoute />
      </PacksProvider>
      </MedicalContextProvider>
      </>
    ),
  },
  {
    path: "/perfil-de-usuario/habitos-de-vida",
    element: (
      <>
      <title>YMC | Hábitos de Vida</title>
      <MedicalContextProvider>
      <PacksProvider>
        <CalculatorHabitsRoute />
      </PacksProvider>
      </MedicalContextProvider>
      </>
    ),
  },
  {
    path: "/perfil-de-usuario/test-findrisk",
    element: (
      <>
      <title>YMC | Riesgo de Diabetes</title>
      <MedicalContextProvider>
      <PacksProvider>
        <CalculatorDiabetesRoute />
      </PacksProvider>
      </MedicalContextProvider>
      </>
    ),
  },
  {
    path: "/perfil-de-usuario/apnea-del-sueno",
    element: (
      <>
      <title>YMC | Apnea del Sueño</title>
      <MedicalContextProvider>
      <PacksProvider>
        <CalculatorSleepRoute />
        </PacksProvider>
      </MedicalContextProvider>
      </>
    ),
  },
  {
    path: "/perfil-de-usuario/sindrome-metabolico",
    element: (
      <>
      <title>YMC | Síndrome Metabólico</title>
      <MedicalContextProvider>
      <PacksProvider>
        <CalculatorMetabolicRoute />
        </PacksProvider>
      </MedicalContextProvider>
      </>
    ),
  },
  {
    path: "/packs-de-examenes",
    element: (
      <>
      <title>YMC | Packs de Exámenes</title>
      
      <MedicalContextProvider>
      <PacksProvider>
        <PacksSelectionRoute />
      </PacksProvider>
      </MedicalContextProvider>
      </>
    ),
  },
  {
    path: "/packs-de-examenes/detalles-de-pack",
    element: (
      <>
      <title>YMC | Detalles de Pack</title>
      <MedicalContextProvider>
      <PacksProvider>
        <PackDetailsRoute />
      </PacksProvider>
      </MedicalContextProvider>
      </>
    ),
  },
  {
    path: "/recomendador-de-examenes",
    element: (
      <>
      <title>YMC | Recomendador</title>
      <MedicalContextProvider>
      <PacksProvider>
        <RecommenderRoute />
      </PacksProvider>
      </MedicalContextProvider>
      </>
    ),
  },
  {
    path: "/recomendador-de-examenes/recomendacion",
    element: (
      <>
      <title>YMC | Recomendación</title>
      <MedicalContextProvider>
      <PacksProvider>
        <RecommendedExamsRoute />
      </PacksProvider>
      </MedicalContextProvider>
      </>
    ),
  },
  {
    path: "/orden-medica",
    element: (
      <>
      <title>YMC | Orden Médica</title>
      <MedicalContextProvider>
      <PacksProvider>
        <OrderCheckoutRoute />
      </PacksProvider>
      </MedicalContextProvider>
      </>
    ),
  },
  {
    path: "/orden-medica/descargar-orden",
    element: (
      <>
      <title>YMC | Descargar Orden</title>
      <MedicalContextProvider>
      <PacksProvider>
        <OrderDownloadRoute />
      </PacksProvider>
      </MedicalContextProvider>
      </>
    ),
  },
  {
    path: "/orden-medica/historial-de-ordenes",
    element: (
      <>
      <title>YMC | Descargar Orden</title>
      <MedicalContextProvider>
      <PacksProvider>
        <OrderRecoveryRoute />
      </PacksProvider>
      </MedicalContextProvider>
      </>
    ),
  },
  {
    path: "/orden-medica/esperando-pago",
    element: (
      <>
      <title>YMC | Descargar Orden</title>
      <MedicalContextProvider>
      <PacksProvider>
        <OrderPendingRoute />
      </PacksProvider>
      </MedicalContextProvider>
      </>
    ),
  },
  //{
  //  path: "/perfil-de-usuario/campañas-empresa",
  //  element: (
  //    <>
  //    <title>YMC | Campañas Empresa</title>
  //    <MedicalContextProvider>
  //    <PacksProvider>
  //      <CompanyCampaigns />
  //    </PacksProvider>
  //    </MedicalContextProvider>
  //    </>
  //  ),
  //},
  //{
  //  path: "/perfil-de-usuario/cupones",
  //  element: (
  //    <>
  //    <title>YMC | Canjear Cupones</title>
  //    <MedicalContextProvider>
  //    <PacksProvider>
  //      <CheckoutCoupons />
  //    </PacksProvider>
  //    </MedicalContextProvider>
  //    </>
  //  ),
  //},
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GoogleOAuthProvider clientId="373324863794-24umjtie522qdma9b4kro9lg8q7804nj.apps.googleusercontent.com">
  <RouterProvider router={Router} />
  </GoogleOAuthProvider>
);

reportWebVitals();
